<template>
  <div style="height:calc(100vh - 100px); overflow-y:auto; overflow-x:hidden;">
    <!-- <b-overlay :show="isLoading" rounded="sm">
      
    </b-overlay>-->
    <b-row class="pl-5 pr-5">
      <b-col cols="12">
        <b-card
          class="rounded-bottom shadow-sm"
          style="background-color:#FFFBF2;"
        >
          <h3 class="pl-3">{{ employeData.first_name }} {{ employeData.last_name }}</h3>

          <b-button variant="outline-success">Export Data</b-button>
          <div class="text-right">
            <b-button
              size="sm"
              variant="outline-warning"
              @click="updateStatus(3)"
            >Terminate</b-button>
          </div>
          <hr />
          <b-row>
            <b-col
              class="display-flex"
              cols="6"
            >
              <b-row>
                <b-col cols="2">
                  <img
                    v-if="profileImage"
                    class="img-style"
                    :src="profileImage"
                    alt="Profile Image"
                  />
                  <b-card
                    v-else
                    style="width: 6rem;"
                  >
                    <font-awesome-icon
                      icon="user"
                      size="4x"
                    />
                  </b-card>
                </b-col>
                <b-col
                  style="margin-left:100px"
                  cols="4"
                >
                  <p>First Name: {{ employeData.first_name }}</p>
                  <p>Last Name: {{ employeData.last_name }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <div class="text-right">
                <p>Employee No: {{ employeData.id }}</p>
                <p>
                  Email:
                  <a :href="'mailto:' + employeData.email">
                    {{
                    employeData.email
                    }}
                  </a>
                </p>
                <p>Division Unit: {{ employeData.department }}</p>
                <p>Residence: {{ employeData.country }}</p>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="pl-3 pr-3 mt-3">
      <b-col cols="12">
        <b-card class="p-3">
          <b-tabs justified>
            <b-tab title="DETAILS">Show all information from add employee</b-tab>
            <b-tab title="TASKS">
              <b-card>
                <b-overlay
                  :show="employeeTasksLoading"
                  rounded="sm"
                >
                  <b-navbar
                    toggleable="lg"
                    type="dark"
                    variant="light"
                  >
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-navbar-brand
                      href="#"
                      class="text-dark"
                    >
                      <strong>Tasks</strong>
                    </b-navbar-brand>

                    <b-collapse
                      id="nav-collapse"
                      is-nav
                    >
                      <!-- Right aligned nav items -->
                      <b-navbar-nav class="ml-auto">
                        <b-nav-form>
                          <b-button
                            variant="outline-info"
                            size="sm"
                            class="mr-2"
                            @click="reloadTasksTable"
                          >
                            <font-awesome-icon icon="sync" />
                          </b-button>
                          <b-form-group>
                            <b-input-group size="sm">
                              <b-form-input
                                v-model="tasksFilter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  :disabled="!tasksFilter"
                                  @click="tasksFilter = ''"
                                >Clear</b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-nav-form>
                      </b-navbar-nav>
                    </b-collapse>
                  </b-navbar>
                  <b-table
                    class="mx-1"
                    sticky-header="calc(100vh - 200px)"
                    ref="table"
                    bordered
                    id="tasks-data-table"
                    :busy.sync="employeeTasksLoading"
                    :items="getOnboardingTaskData"
                    :fields="tasksFields"
                    :filter="tasksFilter"
                    :per-page="tasksPerPage"
                    :current-page="tasksCurrentPage"
                    :sort-by.sync="tasksSortBy"
                    :sort-desc.sync="tasksSortDesc"
                    responsive="sm"
                  >
                    <template v-slot:cell(created_at)="data">
                      <p>{{ createdAtDate(data.item.created_at) }}</p>
                    </template>
                    <template v-slot:cell(task_title)="data">
                      <p v-if="data.item.form_type == 4">{{data.item.task_title}}</p>
                      <p
                        v-else
                        class="link-text"
                        @click="setUserTaskUrl(data)"
                      >{{data.item.task_title}}</p>
                    </template>
                    <template v-slot:cell(task_status)="data">
                      <b-badge
                        v-if="data.item.task_status == '0'"
                        variant="info"
                      >Open</b-badge>
                      <b-badge
                        v-if="data.item.task_status == '1'"
                        variant="warning"
                      >In Progress</b-badge>
                      <b-badge
                        v-if="data.item.task_status == '2'"
                        variant="danger"
                      >On hold</b-badge>
                      <b-badge
                        v-if="data.item.task_status == '3'"
                        variant="dark"
                      >Review</b-badge>
                      <b-badge
                        v-if="data.item.task_status == '4'"
                        variant="success"
                      >Complete</b-badge>
                    </template>
                  </b-table>
                  <p class="text-center mt-3">
                    Showing Result From
                    <b>{{ tasksFromRows }}</b> to
                    <b>{{ tasksToRows }}</b>
                  </p>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="tasksPerPage"
                        id="perPageSelect"
                        size="sm"
                        :options="tasksPageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col>
                      <b-pagination
                        class="float-right"
                        v-model="tasksCurrentPage"
                        :total-rows="tasksRows"
                        :per-page="tasksPerPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="my-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </b-overlay>
              </b-card>
            </b-tab>
            <b-tab title="GIFTS">
              <b-card>
                <b-overlay
                  :show="employeeGiftsLoading"
                  rounded="sm"
                >
                  <b-navbar
                    toggleable="lg"
                    type="dark"
                    variant="light"
                  >
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-navbar-brand
                      href="#"
                      class="text-dark"
                    >
                      <strong>Gifts</strong>
                    </b-navbar-brand>

                    <b-collapse
                      id="nav-collapse"
                      is-nav
                    >
                      <!-- Right aligned nav items -->
                      <b-navbar-nav class="ml-auto">
                        <b-nav-form>
                          <b-button
                            variant="outline-info"
                            size="sm"
                            class="mr-2"
                            @click="reloadGiftsTable"
                          >
                            <font-awesome-icon icon="sync" />
                          </b-button>
                          <b-form-group>
                            <b-input-group size="sm">
                              <b-form-input
                                v-model="giftsFilter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  :disabled="!giftsFilter"
                                  @click="giftsFilter = ''"
                                >Clear</b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-nav-form>
                      </b-navbar-nav>
                    </b-collapse>
                  </b-navbar>
                  <b-table
                    class="mx-1"
                    sticky-header="calc(100vh - 200px)"
                    ref="table"
                    bordered
                    id="gifts-data-table"
                    :busy.sync="employeeGiftsLoading"
                    :items="getApprovalsData"
                    :fields="giftsFields"
                    :filter="giftsFilter"
                    :per-page="giftsPerPage"
                    :current-page="giftsCurrentPage"
                    :sort-by.sync="giftsSortBy"
                    :sort-desc.sync="giftsSortDesc"
                    responsive="sm"
                  >
                    <template v-slot:cell(created_at)="data">
                      {{
                      createdAtDate(data.item.created_at)
                      }}
                    </template>
                    <template v-slot:cell(status)="data">
                      <b-badge
                        v-if="data.item.status == 1"
                        variant="info"
                      >Open</b-badge>
                      <b-badge
                        v-else-if="data.item.status == 2"
                        variant="success"
                      >Completed</b-badge>
                      <b-badge
                        v-else-if="data.item.status == 3"
                        variant="warning"
                      >Onhold</b-badge>
                      <b-badge
                        v-else-if="data.item.status == 4"
                        variant="danger"
                      >Cancelled</b-badge>
                    </template>
                    <template v-slot:cell(actions)="data">
                      <b-btn
                        :to="'/gifts-approval/' + data.item.id + '/1'"
                        size="sm"
                        variant="outline-warning"
                      >
                        <font-awesome-icon icon="eye" />
                      </b-btn>
                    </template>
                  </b-table>
                  <p class="text-center mt-3">
                    Showing Result From
                    <b>{{ giftsFromRows }}</b> to
                    <b>{{ giftsToRows }}</b>
                  </p>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="giftsPerPage"
                        id="perPageSelect"
                        size="sm"
                        :options="giftsPageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col>
                      <b-pagination
                        class="float-right"
                        v-model="giftsCurrentPage"
                        :total-rows="giftsRows"
                        :per-page="giftsPerPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="my-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </b-overlay>
              </b-card>
            </b-tab>
            <b-tab title="ONBOARDING"></b-tab>

            <!-- <b-tab title="DOCUMENTS">
              <b-card>
                <b-navbar toggleable="lg" type="dark" variant="light">
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand href="#" class="text-dark">
                    <strong>Manage Documents</strong>
                  </b-navbar-brand>

                  <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-form-group
                          label-cols-sm="3"
                          label-align-sm="right"
                          label-size="sm"
                          label-for="filterInput"
                        >
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  bordered
                  ref="table"
                  id="my-table"
                  :fields="staticFieldsDocuments"
                  :items="itemsDocuments"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                ></b-table>
                <p class="mt-3">Current Page: {{ perPage }} rows</p>
                <b-row>
                  <b-col cols="2">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      aria-controls="my-table"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>-->
            <b-tab title="AUDIT TRAIL">
              <b-card>
                <b-card-body
                  class="scrollFlow text-left"
                  style="height: 270px; overflow: auto;"
                >
                  <ul class="timeline">
                    <li>
                      <p class="text-muted">16 June, 2020 - 15:49:26</p>
                      <p class="text-muted">Onboarding request has been sent to the Third Party.</p>
                    </li>
                    <li>
                      <p class="text-muted">16 June, 2020 - 15:49:26</p>
                      <p class="text-muted">Third Party saved by ethiXbase.</p>
                    </li>
                    <li>
                      <p class="text-muted">16 June, 2020 - 15:49:26</p>
                      <p class="text-muted">Instant Due Diligence Report generated by ethiXbase.</p>
                    </li>
                  </ul>
                </b-card-body>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
      <b-overlay
        :show="showUpdateStatus"
        no-wrap
      >
        <template v-slot:overlay>
          <div
            v-if="processing"
            class="text-center p-4 bg-primary text-light rounded"
          >
            <font-awesome-icon
              size="lg"
              icon="cloud-upload-alt"
            />
            <div class="mb-3">Updating...</div>
            <b-progress
              min="1"
              max="20"
              :value="counter"
              variant="success"
              height="3px"
              class="mx-n4 rounded-0"
            ></b-progress>
          </div>
          <div
            v-else
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="false"
            aria-labelledby="form-confirm-label"
            class="text-center p-3"
          >
            <p>
              <strong id="form-confirm-label">Are you sure you want update status for {{employeData.first_name + ' ' + employeData.last_name}}?</strong>
            </p>
            <div>
              <b-button
                variant="outline-success"
                class="mr-3"
                @click="resetUpdateStatus"
              >Cancel</b-button>
              <b-button
                variant="outline-danger"
                @click="updateStatusCall"
              >Yes</b-button>
            </div>
          </div>
        </template>
      </b-overlay>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "EmployeeProfile",
  data () {
    return {
      employeeTasksLoading: false,
      tasksTotalRows: 0,
      tasksFromRows: 0,
      tasksToRows: 0,
      tasksFilter: null,
      tasksPerPage: 10,
      tasksCurrentPage: 1,
      tasksSortBy: "id",
      tasksSortDesc: true,
      tasksPageOptions: [5, 10, 25, 50, 75, 100],
      tasksFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "task_title", label: "Task Title", sortable: true },
        // { key: "title", label: "Form Title", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
      ],
      employeeGiftsLoading: false,
      giftsTotalRows: 0,
      giftsFromRows: 0,
      giftsToRows: 0,
      giftsFilter: null,
      giftsPerPage: 10,
      giftsCurrentPage: 1,
      giftsSortBy: "id",
      giftsSortDesc: true,
      giftsPageOptions: [5, 10, 25, 50, 75, 100],
      giftsFields: [
        {
          key: "created_at",
          label: "Date Filed",
          sortable: true,
        },
        {
          key: "title",
          label: "Approval Type",
          sortable: true,
        },
        // {
        //   key: "currency",
        //   label: "Currency",
        //   sortable: true,
        // },
        {
          key: "amount",
          label: "Amount (USD)",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
      profileImage: null,
      isLoading: false,
      employeData: {},
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFieldsDocuments: [
        {
          key: "File",
          label: "File",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],
      itemsDocuments: [
        {
          File: "TomCarlton_contract",
          date: "12 Jun 2020",
          status: "Uploaded",
        },
        {
          File: "TomCarlton_contract",
          date: "12 Jun 2020",
          status: "Uploaded",
        },
      ],
      statusKey: 0,
      showUpdateStatus: false,
      processing: false,
      counter: 1,
      interval: null,
    };
  },
  computed: {
    tasksRows () {
      return this.tasksTotalRows;
    },
    giftsRows () {
      return this.giftsTotalRows;
    },
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getEmployeeDetail();
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    clearInterval () {
      if ( this.interval ) {
        clearInterval( this.interval );
        this.interval = null;
      }
    },
    updateStatus ( status ) {
      this.statusKey = status;
      this.showUpdateStatus = true;
    },
    updateStatusCall () {
      this.counter = 1;
      this.processing = true;
      this.updateStatusApiCall();
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetUpdateStatus();
            this.$router.push( "/manage-employee" );
          } );
        }
      }, 100 );
    },
    async updateStatusApiCall () {
      let formData = {
        status: this.statusKey,
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      await HTTP(
        "post",
        "api/v1/employees/update/status/" + this.$route.params.id,
        formData
      );
      try {
        this.isLoading = false;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    resetUpdateStatus () {
      this.showUpdateStatus = this.processing = false;
      this.statusKey = 0;
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    setUserTaskUrl ( data ) {
      this.$store.state.selectedTaskType = "/employee-profile/" + this.$route.params.id;
      localStorage.setItem( "selected_task_type", this.$store.state.selectedTaskType );
      if ( data.item.form_type == 1 || data.item.form_type == 8 || data.item.form_type == 10 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/emplyee-user-form/" + data.item.id + "/2" );
      } else if ( data.item.form_type == 3 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/emplyee-training/" + data.item.id + "/2" );
      } else if ( data.item.form_type == 6 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.item.id );
        this.$router.push( "/employee-pdf-training/" + data.item.id + "/2" );
      }
    },
    reloadTasksTable () {
      this.$root.$emit( "bv::refresh::table", "tasks-data-table" );
    },
    async getOnboardingTaskData () {
      let employeeId = this.$route.params.id;
      let formData = {
        filter: this.tasksFilter,
        sort:
          this.tasksSortBy +
          "|" +
          ( this.tasksSortDesc == true ? "desc" : "asc" ),
        per_page: this.tasksPerPage,
        page: this.tasksCurrentPage,
      };
      this.employeeTasksLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = HTTP(
        "post",
        "api/v1/onboarding/employee/tasks/table/" + employeeId,
        formData,
        {
          Authorization: token,
        }
      );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.employeeTasksLoading = false;
          this.tasksFromRows = response.data.from;
          this.tasksToRows = response.data.to;
          this.tasksTotalRows = response.data.total;
          return items;
        } )
        .catch( ( error ) => {
          this.employeeTasksLoading = false;
          return [error];
        } );
    },
    reloadGiftsTable () {
      this.$root.$emit( "bv::refresh::table", "gifts-data-table" );
    },
    async getApprovalsData () {
      let employeeId = this.$route.params.id;
      let formData = {
        filter: this.giftsFilter,
        sort:
          this.giftsSortBy +
          "|" +
          ( this.giftsSortDesc == true ? "desc" : "asc" ),
        per_page: this.giftsPerPage,
        page: this.giftsCurrentPage,
        employee_id: employeeId,
      };
      this.employeeGiftsLoading = true;
      let result = HTTP( "post", "api/v1/approvals/get", formData );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.employeeGiftsLoading = false;
          this.giftsFromRows = response.data.from;
          this.giftsToRows = response.data.to;
          this.giftsTotalRows = response.data.total;
          return items;
        } )
        .catch( ( error ) => {
          this.employeeGiftsLoading = false;
          return [error];
        } );
    },
    async getEmployeeDetail () {
      let fromData = {
        employee_id: this.$route.params.id,
      };
      this.isLoading = true;
      let result = HTTP(
        "post",
        "api/v1/employees/get-employee-detail",
        fromData
      );
      return result
        .then( ( response ) => {
          this.profileImage = response.data.profile_img_url;
          this.employeData = response.data;
          this.isLoading = false;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";

.li {
  margin-bottom: 3px;
}

.img-style {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 200px;
}
</style>
